import React from "react";

function VendasPeriodo({ reportData }) {
  const total = reportData.reduce(
    (acc, produto) => {
      acc.total += produto.TOTAL ?? 0;
      acc.qtde += produto.QTDE ?? 0;
      acc.comissao += produto.COMISSAO ?? 0;
      return acc;
    },
    { total: 0, qtde: 0, comissao: 0 }
  );

  return (
    <table className="min-w-full bg-white border border-solid border-gray-300">
      <thead className="bg-gray-300">
        <tr>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Produto
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
            Quantidade
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
            Comissão
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
            Total
          </th>
        </tr>
      </thead>
      <tbody>
        {reportData.map((row, index) => (
          <tr key={row?.DESCRICAO + index} className="hover:bg-gray-200">
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.CODPROD} - {row.DESCRICAO}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
              {row.QTDE}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
              {Number(row.COMISSAO).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
              {Number(row.TOTAL).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </td>
          </tr>
        ))}
        <tr className="bg-gray-300">
          <td className="font-Roboto px-4 py-2 border-b text-sm font-[600]">
            Total
          </td>
          <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-[600]">
            {total.qtde}
          </td>
          <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-[600]">
            {total.comissao.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </td>
          <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-[600]">
            {total.total.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default VendasPeriodo;
